import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useFeedback } from '../../context/FeedbackContext';
import { getRouteFromPath } from '../../utils/router';

/**
 * Floating feedback button that's accessible from any flow
 * Positioned to avoid interfering with timeline, properties panels, etc.
 * 
 * Positioning strategy:
 * - Bottom-right corner on all devices (except video-composer-v3 and video-stack-composer)
 * - Hidden in video-composer-v3 and video-stack-composer (they have inline buttons instead)
 * - High enough from bottom to avoid timeline
 * - Far enough from right edge to avoid scrollbars
 */
export function FeedbackTrigger() {
  const { openFeedback } = useFeedback();
  
  // Hide floating button in flows that have inline feedback buttons
  const currentRoute = getRouteFromPath(window.location.pathname);
  const hideFloatingButton = currentRoute === 'video-composer-v3' || currentRoute === 'video-stack-composer';
  
  if (hideFloatingButton) {
    return null;
  }

  return (
    <button
      onClick={openFeedback}
      className="fixed bottom-6 right-6 z-[9997] w-14 h-14 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center group"
      aria-label="Send feedback or report a bug"
      title="Send Feedback"
    >
      <MessageCircle size={24} className="group-hover:scale-110 transition-transform" />
      
      {/* Pulse animation indicator */}
      <span className="absolute inset-0 rounded-full bg-blue-600 animate-ping opacity-20" />
    </button>
  );
}

